import React, { useEffect }  from "react";
import { useParams, useLocation } from 'react-router-dom';
import ClientTab from "./components/ClientTab";
import Card from "components/card";
import SectionHeader from "components/section/SectionHeader";
import { connect, useDispatch, useSelector } from "react-redux";
import { getClientDetails } from "../../../redux/client/clientState";
import { Building2 } from "lucide-react";


const ViewClient = ({ }) => { 
	const { clientId } = useParams();
    const location = useLocation();

	const dispatch = useDispatch();
	const recordData = useSelector((state) => state.client.clientDetails?.data);
	const requesting = useSelector((state) => state.client.clientDetails?.requesting);
	const success = useSelector((state) => state.client.clientDetails?.succcess);

	const getRecord = (id) => dispatch(getClientDetails(id));

	let startTab = "details"; 
	if (location.pathname.includes("/client-teams")) startTab = "teams";
	else if (location.pathname.includes("/settings")) startTab = "settings";

	useEffect(() => {
		dispatch(getClientDetails(clientId));
	}, [clientId, dispatch]);

	return (
	    <div className="grid grid-cols-1 gap-4 h-full">
			<Card className="p-0 space-y-4">
				<div className="flex flex-col gap-6 rounded-xl border border-emerald-200 bg-gradient-to-br from-white/10 to-emerald-50/30">
					<div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 
									grid-cols-[1fr_auto] [.border-b]:pb-6"
					>
						<div className="flex items-center gap-3">
							<div className="p-3 rounded-lg bg-emerald-100">
								<Building2 className="w-6 h-6 text-emerald-600" />
							</div>
							<div>
								<h4 className="text-[18px] title-text">{recordData?.clt_name}</h4>
								<p className="muted-text">
									Manage client details, teams, and system access
								</p>
							</div>
						</div>
					</div>
				</div>
				<ClientTab recordId={clientId} startTab={startTab} />
			</Card>
		</div>
    );
};

export default ViewClient;